




import * as breakpoint from '../interfaces/breakpoint';
import {
    getElemHeight,
    mediaBreakpoint,
} from '../lib/dom';
import {createBackBtn} from './back-btn';






function setupNavTop (mainMenu:HTMLElement):void {
    const height = getElemHeight('.main-bar');

    if ( mediaBreakpoint(breakpoint.Dir.Down)(breakpoint.Size.MD) ) {
        mainMenu.style.top = height + 'px';
    } else {
        mainMenu.style.top = 'initial';
    }
}


const setupSubmenu = (menu:HTMLElement):Function => (elem:HTMLElement):void => {
    if ( mediaBreakpoint(breakpoint.Dir.Up)(breakpoint.Size.MD) ) return;

    const link:HTMLElement|null = elem.querySelector(':scope > a');
    const submenu:HTMLElement|null = elem.querySelector(':scope > .sub-menu');

    if ( link && submenu ) {

        const submenuTitle:HTMLElement = document.createElement('li');
        submenuTitle.classList.add('title');
        submenuTitle.innerHTML = link.innerHTML;

        const topLink:HTMLElement = document.createElement('li');
        topLink.classList.add('top-link');
        topLink.append(link.cloneNode(true));

        const innerLink = topLink.querySelector('a');
        if ( link.dataset.mobileName && innerLink ) {
            innerLink.innerHTML = link.dataset.mobileName;
        }

        submenu.prepend(topLink);
        submenu.prepend(submenuTitle);
        submenu.prepend(createBackBtn(() => closeSubmenu(menu)));

        link.addEventListener('click', evt => {
            evt.preventDefault();

            const selectedLink = menu.querySelector('.menu-item.selected');
            if ( selectedLink ) selectedLink.classList.remove('selected');

            elem.classList.add('selected');
            menu.classList.add('submenu-open');
        });
    };
}


function closeSubmenu (menu:HTMLElement) {
    menu.classList.remove('submenu-open');

    const selectedLink = menu.querySelector('.menu-item.selected');
    if ( selectedLink ) selectedLink.classList.remove('selected');
}



export default function setupMobileNav () {
    window.addEventListener('DOMContentLoaded', () => {
        const body : HTMLElement | null = document.querySelector('body');
        const mainMenu : HTMLElement | null = document.querySelector('.main-menu');
        const menu : HTMLElement | null = document.querySelector('.main-menu .menu');
        const toggleNavBtn : HTMLElement | null = document.querySelector('.toggle-mobile-nav');

        if ( toggleNavBtn && mainMenu && menu && body ) {
            setupNavTop(mainMenu);

            window.addEventListener('resize', () => setupNavTop(mainMenu));

            toggleNavBtn.addEventListener('click', ():void => {
                menu.classList.remove('submenu-open');
                mainMenu.classList.toggle('open');
                body.classList.toggle('mobilenav-open');
            });

            mainMenu.querySelectorAll('.menu > .menu-item-has-children')
                .forEach(elem => setupSubmenu(menu)(elem));
        }
    });
}
